import { GET_ORDER_GETTERS } from "@/store/storeConstants"
export default {
    [GET_ORDER_GETTERS]:(state)=>{
        return state.orderDetail[0]
    }
}